import { type FormEvent } from 'react'
import { snapshot } from 'valtio'
import { customerProxy } from '../../../../../shared/proxies/customerProxy'
import { apiExecuteCustomerDetailsCardDelete } from '../apiExecuteCustomerDetailsCardDelete'
import { addToArray } from '../../../../../shared/utils/arrayUtils'
import { CardAddFormFieldNamesEnum } from '../../../../../shared/components/CardAddSlideOver/cardAddFormFieldNamesEnum'
import {
  customerAddProxy
} from '../../../../../shared/components/CustomerAddSlideOver/customerAddProxy'

export const closeModal = (): void => { customerProxy.displayDeleteModal = false }

export const handleSubmit = async (e: FormEvent<HTMLFormElement>): Promise<void> => {
  e.preventDefault()
  const { apiCall, customerCard } = snapshot(customerProxy)
  if (apiCall.error) { return }

  if (customerCard) {
    const deleted = await apiExecuteCustomerDetailsCardDelete(customerCard.id)
    const { apiCallCustomerCardDelete } = snapshot(customerProxy)
    if (apiCallCustomerCardDelete.error || !deleted) { return }
  }

  customerProxy.displayDeleteModal = false
  customerProxy.customerCard = null
}

export function populateCustomerInformationForEdit (): void {
  const customer = customerProxy.customer
  if (customer) {
    customerAddProxy.formValues.companyName = customer.companyName
    customerAddProxy.formDirty = addToArray(customerAddProxy.formDirty, CardAddFormFieldNamesEnum.Company)

    customerAddProxy.formValues.firstName = customer.firstName
    customerAddProxy.formDirty = addToArray(customerAddProxy.formDirty, CardAddFormFieldNamesEnum.FirstName)

    customerAddProxy.formValues.lastName = customer.lastName
    customerAddProxy.formDirty = addToArray(customerAddProxy.formDirty, CardAddFormFieldNamesEnum.LastName)

    customerAddProxy.formValues.streetAddressOne = customer.addressOne
    customerAddProxy.formDirty = addToArray(customerAddProxy.formDirty, CardAddFormFieldNamesEnum.StreetAddressOne)

    if (customer.addressTwo) {
      customerAddProxy.formValues.streetAddressTwo = customer.addressTwo
      customerAddProxy.formDirty = addToArray(customerAddProxy.formDirty, CardAddFormFieldNamesEnum.StreetAddressTwo)
    }

    customerAddProxy.formValues.city = customer.city
    customerAddProxy.formDirty = addToArray(customerAddProxy.formDirty, CardAddFormFieldNamesEnum.City)

    customerAddProxy.formValues.state = customer.state
    customerAddProxy.formDirty = addToArray(customerAddProxy.formDirty, CardAddFormFieldNamesEnum.State)

    customerAddProxy.formValues.postalCode = customer.postalCode
    customerAddProxy.formDirty = addToArray(customerAddProxy.formDirty, CardAddFormFieldNamesEnum.PostalCode)

    customerAddProxy.formValues.countryCode = customer.countryCode
    customerAddProxy.formDirty = addToArray(customerAddProxy.formDirty, CardAddFormFieldNamesEnum.CountryCode)

    customerAddProxy.formValues.email = customer.email
    customerAddProxy.formDirty = addToArray(customerAddProxy.formDirty, CardAddFormFieldNamesEnum.Email)

    if (customer.parentCustomerId) {
      customerAddProxy.parentCustomer = customerProxy.currentParentCustomer
      customerAddProxy.parentCustomerId = customer.parentCustomerId
    }
  }
}
